angular
	.module 'App.Repository'
	.factory 'PurchaseOrderRepository', ['ProductRepository', 'BaseRepository', 'CopyService', (ProductRepository, BaseRepository, CopyService) ->
		class PurchaseOrderRepository extends BaseRepository
			@resource = '/purchase_orders'
			@isRestricted = true

			getEntity: (id, query = null, emptyValue = {}) ->
				if _.isEmpty query
					query = @createQuery()
					query.with 'line_items', 'shop'

				return super(id, query, emptyValue)
					.then (purchaseOrder) =>
						if _.isEmpty purchaseOrder.line_items
							return purchaseOrder

						return @_loadProducts(purchaseOrder)
							.then ->
								return purchaseOrder

			_loadProducts: (purchaseOrder) ->
				lineItemChunks = _.chunk(purchaseOrder.line_items, 100)
				promises = []

				for lineItemChunk in lineItemChunks
					promises.push @_loadChunkProducts(lineItemChunk)

				return @all(promises)

			_loadChunkProducts: (lineItemChunk) ->
					query = ProductRepository.createQuery()
					query.with 'product_data',
						'stock_values'
						'product_variants'
						'product_variants>product_data'
						'product_variants>stock_values'

					query.criteria 'id',
						'IN',
						_.chain(lineItemChunk)
							.pluck('product_id')
							.unique()
							.value()

					return ProductRepository
						.getEntities(query)
						.then (products) =>
							for lineItem in lineItemChunk
								product = _.find(products, {id: lineItem.product_id})

								if !product?
									lineItem.product = null
									lineItem.product_variant = null

									continue

								product = CopyService.copy(product)
								lineItem.product_variant = _.find(product.product_variants, {id: lineItem.product_variant_id})

								delete product.product_variants

								lineItem.product = product

		return new PurchaseOrderRepository
	]
